import React, { Component } from 'react'
import {Link, StaticQuery, graphql} from 'gatsby'
import abstractMenu from './abstractMenu';

//Can't dynamically change staticquery, so just making a basic
//component here for TULSA and then another for other menu items
class ProgramMenu extends Component {

  render(){
    let tulsaOut = <StaticQuery
    query={graphql`
        query {
            allNodeProstateMri(filter: {status: {eq: true}}, sort: {order: ASC, fields: title}) {
                nodes {
                    title
                    fields { slug }
                }
            }
            allSitePage { nodes { path } }
        }
    `}
    render={data => {
        let nodes = data.allNodeProstateMri.nodes
        let existingPaths = new Set((data.allSitePage.nodes || []).map(n => n.path))
        let filteredNodes = nodes.filter(node => node.title !== "Axumin®" && node.title !== "PSMA PET/CT" && node.title !== "Interview with Dr. Princenthal" && existingPaths.has(node.fields.slug));
        let output = filteredNodes.map((link, i)=>{
            return (
                <li key={i}><Link className="button" to={link.fields.slug}>{link.title}</Link></li>
            )
        })
        return output
    }}/>

    if(!this.props.mobile){
      return (
        <li className="tulsa-menu" onMouseOver={() => {
            this.props.setMenu({menu: true}, ()=> {
                document.addEventListener('click', this.props.hideDropdownMenu)
            })
        }} onMouseOut={() => {
            this.props.setMenu({menu: false})
        }} ><Link to="/prostate-mri">Prostate MRI</Link>
          <ul className={`tulsa-inner-menu ${this.props.menu ? 'show': 'hide'}`} onMouseOut={() => {
              this.props.setMenu({menu: false})
          }}>
             <li><Link className="button" to="/prostate-mri/">Overview</Link></li>
             {tulsaOut}
          </ul>
        </li>
      )
    }else {
      return (
        <li><a href='#' onClick={e => {
            e.preventDefault()
            this.props.setMenu({menu: true}, ()=> {
                document.addEventListener('click', this.props.hideDropdownMenu)
            })
        }}>Prostate MRI</a>
          <ul className={`${this.props.menu ? 'show': 'hide'}`} >
             <li><Link className="button" to="/prostate-mri/">Overview</Link></li>
             {tulsaOut}
          </ul>
        </li>
      )
    }
  }
}

export default abstractMenu(ProgramMenu)
